import * as echarts from 'echarts';
let animationDuration = 2000;


function getColor(color1, color2) {
	return new echarts.graphic.LinearGradient(
		0, 0, 0, 1, // 从上到下渐变
		[{
			offset: 0,
			color: color1
		}, {
			offset: 1,
			color: color2
		}]
	)
}

function setData(data, name = undefined, color = getColor('#00ffea', '#3ac1ff'), barWidth = '5%') {
	return {
		name,
		data,
		type: 'bar',
		barWidth, // 设置柱子宽度（也可以是具体像素：'30'）
		itemStyle: {
			color
		},
		label: {
			color: '#FFF'
		},
	}
}

function setZData(data, color, name = undefined, areaStyle) {
	return {
		name,
		type: 'line',
		data,
		smooth: true,
		symbol: 'circle',
		symbolSize: 3,
		showSymbol: true,
		lineStyle: {
			width: 2,
			color
		},
		itemStyle: {
			color
		},
		areaStyle: areaStyle ? {
			color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
					offset: 0,
					color: color
				}, // 顶部：线条颜色
				{
					offset: 1,
					color: 'rgba(0,0,0,0)'
				} // 底部：透明
			])
		} : undefined
	}
}


function getGasList(listNum = 8, fixed = 2) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Number((Math.random() * 150 + 50).toFixed(fixed)))
	}
	return val
}


// 客户用电
let monthlist = []
let newMonth = new Date().getMonth() + 1;
for (let i = 11; i > -1; i--) {
	let month = newMonth - i;
	if (month < 1) {
		month = 12 + month;
	}
	monthlist.push(`${month}月`);
}
let months = []
for (let i = 1; i < 13; i++) {
	months.push(`${i}月`);
}
export const chart1 = {
	animationDuration,
	xAxis: {
		type: 'category',
		data: monthlist,
		axisLabel: {
			color: '#FFF' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	tooltip: {
		trigger: 'item',
	},
	grid: {
		top: 30,
		left: 30,
		right: 30,
		bottom: 20,
	},
	legend: {
		// orient: 'vertical',
		symbol: 'circle',
		// right: 80,
		top: 10,
		itemGap: 16,
		itemWidth: 12,
		itemHeight: 12,
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 12
		}
	},
	yAxis: [{
		type: 'value',
		axisLabel: {
			color: '#FFF', // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	}, {
		type: 'value',
		name: '(%)',
		nameTextStyle: {
			color: '#FFF',
			align: 'center',
			padding: [0, 0, 0, 34]
		},
		min: 0,
		max: 100,
		right: 0,
		interval: 20,
		splitLine: {
			show: false
		}, // 不显示辅助线,
		axisLabel: {
			color: '#FFF', // 红色字体
			formatter: '{value}'
		}
	}],
	series: [
		setData(getGasList(12), '工单总数', getColor('#62E4F9', '#0668D4'), '26%'),
		setData(getGasList(12), '完成数', getColor('#64ED9E', '#28AA5F'), '26%'),
		setZData(getBFBList(12), '#FF9830', '完成率'),
	],
};

function getBFBList(listNum, fixed) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Number((Math.random() * 100).toFixed(fixed)))
	}
	return val
}
function getBFBListMaxMin(listNum, Max = 100,Min = 60) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Min + Number((Math.random() * (Max - Min)).toFixed(0)))
	}
	return val
}

export const chart2 = {
	animationDuration,
	xAxis: {
		type: 'category',
		data: monthlist,
		axisLabel: {
			color: '#FFF' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	tooltip: {
		trigger: 'item',
	},
	grid: {
		top: 30,
		left: 30,
		right: 30,
		bottom: 20,
	},
	legend: {
		// orient: 'vertical',
		symbol: 'circle',
		// right: 80,
		top: 10,
		itemGap: 16,
		itemWidth: 12,
		itemHeight: 12,
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 12
		}
	},
	yAxis: [{
		type: 'value',
		axisLabel: {
			color: '#FFF', // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	}, {
		type: 'value',
		name: '(%)',
		nameTextStyle: {
			color: '#FFF',
			align: 'center',
			padding: [0, 0, 0, 34]
		},
		min: 0,
		max: 100,
		right: 0,
		interval: 20,
		splitLine: {
			show: false
		}, // 不显示辅助线,
		axisLabel: {
			color: '#FFF', // 红色字体
			formatter: '{value}'
		}
	}],
	series: [
		setData(getGasList(12), '回访数', getColor('#62E4F9', '#0668D4'), '26%'),
		setZData(getBFBList(12), '#FF9830', '回访率'),
		setZData(getBFBList(12), '#27A45D', '满意率'),
	],
};


export const chart3 = {
	animationDuration,
	tooltip: {
		trigger: 'item'
	},
	// legend: {
	// 	// type: 'scroll',
	// 	// orient: 'vertical',
	// 	symbol: 'circle',
	// 	right: 0,
	// 	left: '50%',
	// 	top: '30%',
	// 	itemGap: 30,
	// 	itemWidth: 14,
	// 	itemHeight: 14,
	// 	borderRadius: 10,
	// 	formatter: function(name, a) {
	// 		return name + '\t\t\t\t\t\t'
	// 	},
	// 	symbolSize: [12, 12], // 设置图例圆形的大小
	// 	textStyle: {
	// 		color: '#3ED4EB'
	// 	}
	// },
	series: [{
		name: '工单分类（%）',
		type: 'pie',
		radius: ['60%', '90%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
		},
		top: 20,
		bottom: 10,
		left: 10,
		right: 10,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0
		},
		// roseType: 'radius',
		emphasis: {
			label: {
				show: false,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: [{
				value: 20,
				name: '建筑',
				itemStyle: {
					color: '#3ed4eb'
				},
			},
			{
				value: 10,
				name: '机电',
				itemStyle: {
					color: '#0667d4'
				},
			},
			{
				value: 15,
				name: '暖通',
				itemStyle: {
					color: '#5ade9d'
				},
			},

			{
				value: 38,
				name: '给排水',
				itemStyle: {
					color: '#ff9830'
				},
			},

			{
				value: 17,
				name: '其他',
				itemStyle: {
					color: '#f46566'
				},
			}
		]
	}]
};
export const chart4 = {
	animationDuration,
	tooltip: {
		trigger: 'item'
	},
	// legend: {
	// 	// type: 'scroll',
	// 	// orient: 'vertical',
	// 	symbol: 'circle',
	// 	right: 0,
	// 	left: '50%',
	// 	top: '30%',
	// 	itemGap: 20,
	// 	itemWidth: 14,
	// 	itemHeight: 14,
	// 	borderRadius: 10,
	// 	// formatter: function(name,a){
	// 	// 	return name + '\t\t\t'
	// 	// },
	// 	symbolSize: [12, 12], // 设置图例圆形的大小
	// 	textStyle: {
	// 		color: '#3ED4EB'
	// 	}
	// },
	series: [{
		name: '工单来源（%）',
		type: 'pie',
		radius: ['60%', '90%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 20,
		bottom: 10,
		left: 10,
		right: 10,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0
		},
		// roseType: 'radius',
		emphasis: {
			label: {
				show: false,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: [{
				value: 66.67,
				name: '来电、微信、邮件',
				itemStyle: {
					color: '#5655F5'
				},
			},
			{
				value: 22.33,
				name: '客户小程序',
				itemStyle: {
					color: '#F2C13C'
				},
			},
			{
				value: 11,
				name: '员工APP',
				itemStyle: {
					color: '#30D582'
				},
			},
		]
	}]
};

let chart5Value = getGasList(6);
export const chart5 = {
	animationDuration,
	xAxis: {
		type: 'category',
		data: months,
		axisLabel: {
			color: '#FFF' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	tooltip: {
		trigger: 'item',
	},
	grid: {
		top: 30,
		left: 30,
		right: 30,
		bottom: 20,
	},
	legend: {
		// orient: 'vertical',
		symbol: 'circle',
		// right: 80,
		top: 10,
		itemGap: 16,
		itemWidth: 12,
		itemHeight: 12,
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 12
		}
	},
	yAxis: [{
		type: 'value',
		axisLabel: {
			color: '#FFF', // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	}, {
		type: 'value',
		name: '(%)',
		nameTextStyle: {
			color: '#FFF',
			align: 'center',
			padding: [0, 0, 0, 34]
		},
		min: 0,
		max: 100,
		right: 0,
		interval: 20,
		splitLine: {
			show: false
		}, // 不显示辅助线,
		axisLabel: {
			color: '#FFF', // 红色字体
			formatter: '{value}'
		}
	}],
	series: [
		setData(chart5Value, '工单总数', getColor('#62E4F9', '#0668D4'), '26%'),
		setData(chart5Value.map(item=>item-(Math.floor(Math.random() * 50))), '完成数', getColor('#64ED9E', '#28AA5F'), '26%'),
		setZData(getBFBListMaxMin(6), '#FF9830', '完成率'),
	],
};


function getBFBMinList(listNum, fixed) {
	let val = [];
	for (let i = 0; i < listNum; i++) {
		val.push(Number((80 + (Math.random() * 20)).toFixed(fixed)))
	}
	return val
}

export const chart6 = {
	animationDuration,
	xAxis: {
		type: 'category',
		data: months,
		axisLabel: {
			color: '#FFF' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	tooltip: {
		trigger: 'item',
	},
	grid: {
		top: 40,
		left: 30,
		right: 20,
		bottom: 20,
	},
	legend: {
		// orient: 'vertical',
		symbol: 'circle',
		// right: 80,
		top: 10,
		itemGap: 16,
		itemWidth: 12,
		itemHeight: 12,
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 12
		}
	},
	yAxis: {
		type: 'value',
		name: '(%)',
		nameTextStyle: {
			color: '#FFF',
			align: 'center',
			padding: [0, 30, 0, 0]
		},
		min: 60,
		max: 100,
		right: 0,
		interval: 20,
		splitLine: {
			show: false
		}, // 不显示辅助线,
		axisLabel: {
			color: '#FFF', // 红色字体
			formatter: '{value}'
		}
	},
	series: [
		setZData(getBFBMinList(6), '#488BFE', '及时完成率', true),
		setZData(getBFBMinList(6), '#A42727', '及时接单率', true),
	],
};